import Vue from 'vue';

const originalEmit = Vue.prototype.$emit;

Vue.prototype.$emit = function(event, ...args) {
  if (window.parent) {
    if (event === 'openSubModal' || event === 'closeModal') {
      try {
        window.parent.postMessage(
          {
            type: 'eventbus:emit',
            data: { event, props: args ? args[0] : [] }
          },
          '*'
        );
      } catch (e) {
        window.parent.postMessage(
          { type: 'eventbus:emit', data: { event } },
          '*'
        );
      }
    }
  }

  // Call original $emits
  return originalEmit.apply(this, [event, ...args]);
};

const eventBus = new Vue();

export default eventBus;
